/**
 * Perioada tablourilor Easeedesk mutate din `easeedesk-dashboards/`.
 *
 * Machetele vechi au in cap casuta `.reportrange` - un `daterangepicker` cu
 * un calendar si sase scurtaturi - care umple `filterFrom` / `filterTo`.
 * Calendarul cu zile alese de mana nu se aduce: ar cere biblioteca
 * `daterangepicker`, care nu e in v4. Scurtaturile sunt cele care se apasa,
 * si sunt aceleasi cuvinte.
 *
 * CAPATUL DE SUS E `23:59:59`. Cu `23:59`, tot ce se intampla in ultimul
 * minut al zilei cade afara din raport, si ziua curenta iese mai saraca decat
 * e. A fost deja un bug din asta.
 */

export const RANGES = [
  'Today',
  'Last 24 Hours',
  'Yesterday',
  'Last 7 Days',
  'Last 30 Days',
  'This Month',
  'Last Month',
] as const

export type RangeName = (typeof RANGES)[number]

export interface Range {
  from: string
  to: string
}

function stamp(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

function edges(from: Date, to: Date): Range {
  return { from: `${stamp(from)} 00:00:00`, to: `${stamp(to)} 23:59:59` }
}

export function rangeOf(name: RangeName, now: Date = new Date()): Range {
  const day = (offset: number) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset)

  switch (name) {
    /*
     * "Leader Board" pornea de la `moment().subtract(23, "hour")` pana acum -
     * o fereastra care se misca, nu o zi. Aici e ea, in lista, ca sa nu se
     * piarda perioada cu care se deschidea ecranul.
     */
    case 'Last 24 Hours': {
      const stampTime = (d: Date) =>
        `${stamp(d)} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`

      return { from: stampTime(new Date(now.getTime() - 23 * 3600 * 1000)), to: stampTime(now) }
    }
    case 'Yesterday':
      return edges(day(-1), day(-1))
    case 'Last 7 Days':
      return edges(day(-6), day(0))
    case 'Last 30 Days':
      return edges(day(-29), day(0))
    case 'This Month':
      return edges(new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0))
    case 'Last Month':
      return edges(new Date(now.getFullYear(), now.getMonth() - 1, 1), new Date(now.getFullYear(), now.getMonth(), 0))
    default:
      return edges(day(0), day(0))
  }
}

/** `?from=&to=`, in forma pe care o trimiteau casutele ascunse ale machetei. */
export function rangeQuery(range: Range): string {
  const p = new URLSearchParams({ from: range.from, to: range.to })

  return p.toString()
}
